/* eslint-disable */
import { contactsCollection, ordersCollection, ticketsCollection } from "@/config/firebase";
import { roles } from "@/helpers/get_constants";
import getCurrentUser from "@/helpers/get_current_user";
import store from "@/store";
// import { wegrou } from "Config/config";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const allRoles = [
  roles.ADVISOR,
  roles.SUPERVISOR,
  roles.ADMIN,
  roles.SUPER_ADMIN,
  roles.ENTREPRENEUR,
  roles.ADVISOR_LEVEL1,
  roles.ADVISOR_LEVEL2,
];

const middlewareVerifySubcription = async (to, from, next, nextMiddleware) => {
  if ([roles.SUPER_ADMIN, roles.ADMIN, roles.ADVISOR].includes(store.state.Agent.agent.role)) return next();

  const subscription = store.state.Subscription.subscription;
  if (!subscription) await store.dispatch("getSubscriptionConfig");

  if (store.state.Subscription.subscription?.status === "suspend") {
    next("/subscription-required");
  } else {
    if (nextMiddleware) nextMiddleware(to, from, next);
    else next();
  }
};

const middlewareVerifyOrder = async (to, from, next) => {
  const response = await ordersCollection.doc(to.params.id).get();
  if (response.exists) {
    if (
      [roles.SUPER_ADMIN, roles.ADMIN, roles.SUPERVISOR].includes(to.meta.user.role) ||
      (roles.ENTREPRENEUR === to.meta.user.role && response.data().team_id === to.meta.user.team_id) ||
      ([roles.ADVISOR_LEVEL1, roles.ADVISOR_LEVEL2].includes(to.meta.user.role) &&
        response.data().agent_id === to.meta.user.uid)
    ) {
      next();
    } else {
      next("/orders");
    }
  } else {
    next("/orders");
  }
};

const middlewareVerifyOpportunity = async (to, from, next) => {
  const response = await ticketsCollection.doc(to.params.id).get();
  if (response.exists) {
    if (
      [roles.SUPER_ADMIN, roles.ADMIN].includes(to.meta.user.role) ||
      ([roles.SUPERVISOR, roles.ENTREPRENEUR].includes(to.meta.user.role) &&
        response.data().team_id === to.meta.user.team_id) ||
      to.meta.user.uid === response.data().agent_id
    ) {
      next();
    } else {
      next("/opportunities");
    }
  } else {
    next("/opportunities");
  }
};

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      redirect: () => {
        let route = "/opportunities";

        const agent = store.state.Agent.agent;

        switch (agent?.role) {
          case roles.ADVISOR_LEVEL1:
            route = "/orders";
            break;
          case roles.ENTREPRENEUR:
            route = "/catalog/products";
            break;
        }

        if (!agent && store.state.Agent.isAgentAuthenticated) route = "/affiliate-business";

        return route;
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import(/* webpackChunkName: "login" */ "@/views/auth/Login"),
      meta: {
        layout: "Auth",
        authorizedRoles: ["anonymous"],
      },
    },
    {
      path: "/auth",
      name: "auth",
      component: () => import(/* webpackChunkName: "auth" */ "@/views/auth/Auth"),
      meta: {
        layout: "Auth",
        authorizedRoles: ["anonymous"],
      },
    },
    {
      path: "/email-validation",
      name: "auth_email_validation",
      component: () => import(/* webpackChunkName: "email-validation" */ "@/views/auth/EmailValidation"),
      meta: {
        title: "Validar correo electrónico",
        authorizedRoles: allRoles,
      },
    },
    {
      path: "/affiliate-business",
      name: "auth_affiliate_business",
      component: () => import(/* webpackChunkName: "affiliate-business" */ "@/views/auth/AffiliateBusiness"),
      meta: {
        layout: "Auth",
        title: "Completar registro de negocio",
        // authorizedRoles: ["user"],
      },
    },
    {
      path: "/contacts",
      name: "contacts",
      props: (route) => ({ state: route.query.state, country: route.query.country, agent: route.query.agent }),
      component: () => import(/* webpackChunkName: "contacts" */ "@/views/contacts/Contacts"),
      meta: {
        title: "Contactos",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ADMIN, roles.SUPERVISOR, roles.ADVISOR, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/contacts/importer",
      name: "importer_contacts",
      component: () => import(/* webpackChunkName: "contacts-importer" */ "@/views/contacts/options/Importer"),
      meta: {
        title: "Contactos",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ADMIN, roles.SUPERVISOR, roles.ADVISOR, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/contacts/importer-activities",
      name: "importer_contact_activities",
      component: () =>
        import(/* webpackChunkName: "contacts-importer-activities" */ "@/views/contacts/options/ImporterActivities"),
      meta: {
        title: "Contactos",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ADMIN, roles.SUPERVISOR, roles.ADVISOR, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/contacts/register",
      name: "contact_register",
      component: () => import(/* webpackChunkName: "contacts-register" */ "@/views/contacts/options/Register"),
      meta: {
        title: "Contactos",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ADMIN, roles.SUPERVISOR, roles.ADVISOR, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/contacts/:id",
      name: "contact_detail",
      component: () => import(/* webpackChunkName: "contacts-detail" */ "@/views/contacts/options/Detail"),
      meta: {
        title: "Contactos",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ADMIN, roles.SUPERVISOR, roles.ADVISOR, roles.ENTREPRENEUR],
      },
      async beforeEnter(to, from, next) {
        let response = await contactsCollection.doc(to.params.id).get();
        if (response.exists) {
          if (
            [roles.SUPER_ADMIN, roles.ADMIN].includes(to.meta.user.role) ||
            ([roles.SUPERVISOR, roles.ENTREPRENEUR].includes(to.meta.user.role) &&
              response.data().team_id === to.meta.user.team_id) ||
            to.meta.user.uid === response.data().agent_id
          ) {
            next();
          } else {
            next("/contacts");
          }
        } else {
          next("/contacts");
        }
      },
    },
    {
      path: "/orders",
      name: "orders",
      component: () => import(/* webpackChunkName: "orders" */ "@/views/orders/Orders"),
      meta: {
        title: "Venta",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL1,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/orders/register",
      name: "order_register",
      component: () => import(/* webpackChunkName: "orders-register" */ "@/views/orders/options/Register"),
      meta: {
        title: "Nueva venta",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL1,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/orders/report",
      name: "order_report",
      component: () => import(/* webpackChunkName: "orders-report" */ "@/views/orders/options/Report"),
      meta: {
        title: "Reporte de ventas",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL1,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/orders/importer",
      name: "order_importer",
      component: () => import(/* webpackChunkName: "orders-importer" */ "@/views/orders/options/Importer"),
      meta: {
        title: "Importador de ventas",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL1,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/orders/:id",
      name: "order_detail",
      component: () => import(/* webpackChunkName: "orders-detail" */ "@/views/orders/options/Detail"),
      meta: {
        title: "Detalle de venta",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL1,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next, middlewareVerifyOrder);
      },
    },
    {
      path: "/opportunities",
      name: "tickets",
      component: () => import(/* webpackChunkName: "tickets" */ "@/views/tickets/Tickets"),
      meta: {
        title: "Oportunidades",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/opportunities/report",
      name: "tickets_report",
      component: () => import(/* webpackChunkName: "tickets-report" */ "@/views/tickets/options/Report"),
      meta: {
        title: "Reporte de Detalle de Oportunidades",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ENTREPRENEUR, roles.SUPERVISOR, roles.ADVISOR_LEVEL2],
      },
    },
    {
      path: "/opportunities/dashboard",
      name: "ticket_dashboard",
      component: () => import(/* webpackChunkName: "tickets-dashboard" */ "@/views/tickets/options/Dashboard"),
      meta: {
        title: "Dashboard Oportunidades",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/opportunities/register",
      name: "ticket_register",
      component: () => import(/* webpackChunkName: "tickets-register" */ "@/views/tickets/options/Register"),
      meta: {
        title: "Nueva oportunidad",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/opportunities/importer",
      name: "importer_tickets",
      component: () => import(/* webpackChunkName: "tickets-importer" */ "@/views/tickets/options/Importer"),
      meta: {
        title: "Tickets",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/opportunities/fields/importer",
      name: "ticket_fields_importer",
      component: () =>
        import(
          /* webpackChunkName: "ticket-fields-importer" */ "@/views/tickets/options/ticketFields/options/Importer"
        ),
      meta: {
        title: "Campos del importador de oportunidades",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/opportunities/importer-activities",
      name: "importer_ticket_activities",
      component: () =>
        import(/* webpackChunkName: "tickets-importer-activities" */ "@/views/tickets/options/ImporterActivities"),
      meta: {
        title: "Tickets",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/opportunities/report-activities",
      name: "report_activities",
      component: () =>
        import(/* webpackChunkName: "tickets-reporter-activities" */ "@/views/tickets/options/ReportActivities"),
      meta: {
        title: "Tickets",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/opportunities/downloads",
      name: "ticket_downloads",
      component: () => import(/* webpackChunkName: "tickets-downloads" */ "@/views/tickets/options/Downloads"),
      meta: {
        title: "Tickets",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/opportunities/downloads/register",
      name: "ticket_downloads_register",
      component: () =>
        import(/* webpackChunkName: "tickets-downloads-register" */ "@/views/tickets/options/downloads/Register"),
      meta: {
        title: "Tickets",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/opportunities/history-download",
      name: "history_download",
      component: () =>
        import(/* webpackChunkName: "history-download" */ "@/views/tickets/options/downloads/HistoryDownload"),
      meta: {
        title: "Descarga de historial",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/opportunities/fields",
      name: "ticket_fields",
      component: () =>
        import(/* webpackChunkName: "ticket-fields" */ "@/views/tickets/options/ticketFields/TicketFields"),
      meta: {
        title: "Campos de oportunidad",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/opportunities/fields/sort",
      name: "ticket_fields_sort",
      component: () =>
        import(/* webpackChunkName: "ticket-fields-sort" */ "@/views/tickets/options/ticketFields/options/Sort"),
      meta: {
        title: "Ordenar campos de oportunidad",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/opportunities/fields/register",
      name: "ticket_fields_register",
      component: () =>
        import(
          /* webpackChunkName: "ticket-fields-register" */ "@/views/tickets/options/ticketFields/options/Register"
        ),
      meta: {
        title: "Nuevo campo de oportunidad",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/opportunities/fields/:id",
      name: "ticket_fields_detail",
      component: () =>
        import(/* webpackChunkName: "ticket-fields-detail" */ "@/views/tickets/options/ticketFields/options/Detail"),
      meta: {
        title: "Detalle del campo de oportunidad",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/opportunities/states",
      name: "ticket_states",
      component: () =>
        import(/* webpackChunkName: "ticket-states" */ "@/views/tickets/options/ticketStates/TicketStates"),
      meta: {
        title: "Estados de oportunidad",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/opportunities/states/register",
      name: "ticket_states_register",
      component: () =>
        import(
          /* webpackChunkName: "ticket-states-register" */ "@/views/tickets/options/ticketStates/options/Register"
        ),
      meta: {
        title: "Nuevo estado de oportunidad",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/opportunities/states/:id",
      name: "ticket_states_detail",
      component: () =>
        import(/* webpackChunkName: "ticket-states-detail" */ "@/views/tickets/options/ticketStates/options/Detail"),
      meta: {
        title: "Detalle del estado de oportunidad",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/opportunities/report/agents-performance",
      name: "agents_performance_report",
      component: () => import(/* webpackChunkName: "agents-performance-report" */ "@/views/agents/options/Report"),
      meta: {
        title: "Reporte de Desempeño del Agente",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ENTREPRENEUR, roles.ADVISOR_LEVEL2],
      },
    },
    {
      path: "/opportunities/:id",
      name: "ticket_detail",
      component: () => import(/* webpackChunkName: "tickets-detail" */ "@/views/tickets/options/Detail"),
      meta: {
        title: "Oportunidades",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next, middlewareVerifyOpportunity);
      },
    },
    {
      path: "/agents",
      name: "agents",
      component: () => import(/* webpackChunkName: "agents" */ "@/views/agents/Agents"),
      meta: {
        title: "Colaboradores",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/agents/register",
      name: "agents_register",
      component: () => import(/* webpackChunkName: "agents-register" */ "@/views/agents/options/Register"),
      meta: {
        title: "Trabajadores",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/agent/:id",
      name: "agents_detail",
      component: () => import(/* webpackChunkName: "agents-detail" */ "@/views/agents/options/Detail"),
      meta: {
        title: "Trabajadores",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/projects",
      name: "projects",
      component: () => import(/* webpackChunkName: "projects" */ "@/views/projects/Projects"),
      meta: {
        title: "Proyectos",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/projects/register",
      name: "projects_register",
      component: () => import(/* webpackChunkName: "projects-register" */ "@/views/projects/options/Register"),
      meta: {
        title: "Proyectos",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/projects/:id",
      name: "projects_detail",
      component: () => import(/* webpackChunkName: "projects-detail" */ "@/views/projects/options/Detail"),
      meta: {
        title: "Detalle del proyecto",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/campaigns",
      name: "campaigns",
      component: () => import(/* webpackChunkName: "campaigns" */ "@/views/campaigns/Campaigns"),
      meta: {
        title: "Campañas",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ADMIN, roles.SUPERVISOR, roles.ADVISOR, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/campaigns/register-budget",
      name: "campaigns_register_budget",
      component: () =>
        import(/* webpackChunkName: "campaigns-register-budget" */ "@/views/campaigns/options/RegisterBudget"),
      meta: {
        title: "Nuevo presupuesto de campaña",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ADMIN, roles.SUPERVISOR, roles.ADVISOR, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/campaigns/download",
      name: "campaign_download",
      component: () =>
        import(/* webpackChunkName: "campaigns-download" */ "@/views/campaigns/options/downloads/Download"),
      meta: {
        title: "Campaigns",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
      beforeEnter(to, from, next) {
        middlewareVerifySubcription(to, from, next);
      },
    },
    {
      path: "/campaigns/report",
      name: "campaigns_report",
      component: () => import(/* webpackChunkName: "campaigns-report" */ "@/views/campaigns/options/Report"),
      meta: {
        title: "Reporte de campañas",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
    },
    {
      path: "/origins",
      name: "origins",
      component: () => import(/* webpackChunkName: "origins" */ "@/views/origins/Origins"),
      meta: {
        title: "Orígenes",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
    },
    {
      path: "/origins/register",
      name: "origins_register",
      component: () => import(/* webpackChunkName: "origins-register" */ "@/views/origins/options/Register"),
      meta: {
        title: "Orígenes",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/origin/:id",
      name: "origins_detail",
      component: () => import(/* webpackChunkName: "origins-detail" */ "@/views/origins/options/Detail"),
      meta: {
        title: "Detalle del origen",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/origins/categories",
      name: "origins_categories",
      component: () =>
        import(/* webpackChunkName: "origins-categories" */ "@/views/originsCategories/OriginsCategories"),
      meta: {
        title: "Categorías",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
    },
    {
      path: "/origins/categories/register",
      name: "origins_categories_register",
      component: () =>
        import(/* webpackChunkName: "origins-categories-register" */ "@/views/originsCategories/options/Register"),
      meta: {
        title: "Nueva categoría",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/events",
      name: "events",
      component: () => import(/* webpackChunkName: "events" */ "@/views/events/Events"),
      meta: {
        title: "Eventos",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
    },
    {
      path: "/calendars",
      name: "calendars",
      component: () => import(/* webpackChunkName: "calendars" */ "@/views/events/calendars/Calendars"),
      meta: {
        title: "Calendarios",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
    },
    {
      path: "/calendars/register",
      name: "calendar_register",
      component: () => import(/* webpackChunkName: "calendars-register" */ "@/views/events/calendars/options/Register"),
      meta: {
        title: "Nuevo calendario",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ADMIN, roles.SUPERVISOR, roles.ADVISOR, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/calendars/detail/:id",
      name: "calendar_detail",
      component: () => import(/* webpackChunkName: "calendars-detail" */ "@/views/events/calendars/options/Detail"),
      meta: {
        title: "Nuevo calendario",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ADMIN, roles.SUPERVISOR, roles.ADVISOR_LEVEL2, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog",
      name: "catalog",
      component: () => import(/* webpackChunkName: "catalog" */ "@/views/catalog/Catalog"),
      meta: {
        title: "Catálogo",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/products",
      name: "catalog_products",
      component: () => import(/* webpackChunkName: "catalog-products" */ "@/views/catalog/products/Products"),
      meta: {
        title: "Productos",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/products/register",
      name: "catalog_product_register",
      component: () =>
        import(/* webpackChunkName: "catalog-products-register" */ "@/views/catalog/products/options/Register"),
      meta: {
        title: "Nuevo producto",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/products/:id",
      name: "catalog_product_detail",
      component: () =>
        import(/* webpackChunkName: "catalog-products-detail" */ "@/views/catalog/products/options/Detail"),
      meta: {
        title: "Detalle del producto",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/categories",
      name: "catalog_categories",
      component: () => import(/* webpackChunkName: "catalog-categories" */ "@/views/catalog/categories/Categories"),
      meta: {
        title: "Categorías",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/categories/register",
      name: "catalog_category_register",
      component: () =>
        import(/* webpackChunkName: "catalog-categories-register" */ "@/views/catalog/categories/options/Register"),
      meta: {
        title: "Nueva categoría",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/categories/:id",
      name: "catalog_category_detail",
      component: () =>
        import(/* webpackChunkName: "catalog-categories-detail" */ "@/views/catalog/categories/options/Detail"),
      meta: {
        title: "Detalle de la categoría",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/collections",
      name: "catalog_collections",
      component: () => import(/* webpackChunkName: "catalog-collections" */ "@/views/catalog/collections/Collections"),
      meta: {
        title: "Colecciones",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/collections/register",
      name: "catalog_collection_register",
      component: () =>
        import(/* webpackChunkName: "catalog-collections-register" */ "@/views/catalog/collections/options/Register"),
      meta: {
        title: "Nueva colección",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/collections/:id",
      name: "catalog_collection_detail",
      component: () =>
        import(/* webpackChunkName: "catalog-collections-detail" */ "@/views/catalog/collections/options/Detail"),
      meta: {
        title: "Detalle de la colección",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/attributes",
      name: "catalog_attributes",
      component: () => import(/* webpackChunkName: "catalog-attributes" */ "@/views/catalog/attributes/Attributes"),
      meta: {
        title: "Atributos de Productos",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/attributes/register",
      name: "catalog_attribute_register",
      component: () =>
        import(/* webpackChunkName: "catalog-attributes-register" */ "@/views/catalog/attributes/options/Register"),
      meta: {
        title: "Nuevo atributo",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/attributes/:id",
      name: "catalog_attribute_detail",
      component: () =>
        import(/* webpackChunkName: "catalog-attributes-detail" */ "@/views/catalog/attributes/options/Detail"),
      meta: {
        title: "Detalle del atributo",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/attribute/:id/variations",
      name: "catalog_attributes_variations",
      component: () =>
        import(/* webpackChunkName: "catalog-attributes-variations" */ "@/views/catalog/attributes/Variations"),
      meta: {
        title: "Variaciones del Productos",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/zones",
      name: "catalog_zones",
      component: () => import(/* webpackChunkName: "zones" */ "@/views/catalog/zones/Zones"),
      meta: {
        title: "Zonas",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/zones/register",
      name: "catalog_zone_register",
      component: () => import(/* webpackChunkName: "zones-register" */ "@/views/catalog/zones/options/Register"),
      meta: {
        title: "Nueva zona",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/zones/:id",
      name: "catalog_zone_detail",
      component: () => import(/* webpackChunkName: "zones-detail" */ "@/views/catalog/zones/options/Detail"),
      meta: {
        title: "Detalle de la zona",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/catalog/payments",
      name: "catalog_payments",
      component: () => import(/* webpackChunkName: "zones-payments" */ "@/views/catalog/payments/Payments"),
      meta: {
        title: "Métodos de pago",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business",
      name: "business",
      redirect: "/business/information",
    },
    {
      path: "/business/information",
      name: "business_information",
      component: () =>
        import(/* webpackChunkName: "business-information" */ "@/views/business/information/Information"),
      meta: {
        title: "Información del negocio",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/stores",
      name: "business_stores",
      component: () => import(/* webpackChunkName: "stores" */ "@/views/business/stores/Stores"),
      meta: {
        title: "Tiendas",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/stores/register",
      name: "business_stores_register",
      component: () => import(/* webpackChunkName: "stores-register" */ "@/views/business/stores/options/Register"),
      meta: {
        title: "Nueva tienda",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/stores/:id",
      name: "business_stores_detail",
      component: () => import(/* webpackChunkName: "stores-detail" */ "@/views/business/stores/options/Detail"),
      meta: {
        title: "Detalle de tienda",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/stores/:storeId/cash_registers",
      name: "store_cash_registers",
      component: () => import(/* webpackChunkName: "cash-registers" */ "@/views/business/stores/options/CashRegisters"),
      meta: {
        title: "Cajas",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/stores/:storeId/cash_registers/register",
      name: "store_cash_register_register",
      component: () =>
        import(
          /* webpackChunkName: "cash-register-register" */ "@/views/business/stores/options/cash-registers/Register"
        ),
      meta: {
        title: "Nueva caja",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/stores/:storeId/cash_registers/report-close",
      name: "store_cash_register_report_close",
      component: () =>
        import(
          /* webpackChunkName: "cash-register-report-close" */ "@/views/business/stores/options/cash-registers/ReportClose"
        ),
      meta: {
        title: "Reporte de cierres",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/stores/:storeId/cash_registers/:id",
      name: "store_cash_register_detail",
      component: () =>
        import(/* webpackChunkName: "cash-register-detail" */ "@/views/business/stores/options/cash-registers/Detail"),
      meta: {
        title: "Detalle de caja",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/files",
      name: "business_files",
      component: () => import(/* webpackChunkName: "business-files" */ "@/views/business/files/Files"),
      meta: {
        title: "Archivos del negocio",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/files/register",
      name: "business_files_register",
      component: () =>
        import(/* webpackChunkName: "business-files-register" */ "@/views/business/files/options/Register"),
      meta: {
        title: "Archivos del negocio",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/files/:id",
      name: "business_file_detail",
      component: () => import(/* webpackChunkName: "business-file-detail" */ "@/views/business/files/options/Detail"),
      meta: {
        title: "Archivo del negocio",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/faqs",
      name: "business_faqs",
      component: () => import(/* webpackChunkName: "business-faqs" */ "@/views/business/faqs/Faqs"),
      meta: {
        title: "FAQs del negocio",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/faqs/:id",
      name: "business_faq_detail",
      component: () => import(/* webpackChunkName: "business-faq-detail" */ "@/views/business/faqs/options/Detail"),
      meta: {
        title: "FAQs del negocio",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/faqs/register",
      name: "business_faqs_register",
      component: () =>
        import(/* webpackChunkName: "business-faqs-register" */ "@/views/business/faqs/options/Register"),
      meta: {
        title: "FAQ del negocio",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/360pay",
      name: "business_360pay",
      component: () => import(/* webpackChunkName: "business-360pay-index" */ "@/views/business/360pay/360pay"),
      meta: {
        title: "360Pay",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/business/360pay/connect",
      name: "business_360pay_connect",
      component: () =>
        import(/* webpackChunkName: "business-360pay-connect" */ "@/views/business/360pay/options/Connect"),
      meta: {
        title: "Conectar 360pay",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels",
      name: "channels",
      component: () => import(/* webpackChunkName: "channels" */ "@/views/channels/Channels"),
      meta: {
        title: "Canales",
        authorizedRoles: [roles.SUPER_ADMIN, roles.ADMIN, roles.SUPERVISOR, roles.ADVISOR, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp",
      name: "channel_whatsapp",
      component: () => import(/* webpackChunkName: "channel-whatsapp" */ "@/views/channels/whatsapp/WhatsApp"),
      meta: {
        title: "Canales > WhatsApp",
        authorizedRoles: [
          roles.SUPER_ADMIN,
          roles.ADMIN,
          roles.SUPERVISOR,
          roles.ADVISOR,
          roles.ENTREPRENEUR,
          roles.ADVISOR_LEVEL2,
        ],
      },
    },
    // {
    //   path: "/channels/whatsapp/old",
    //   name: "channel_whatsapp",
    //   component: () => import(/* webpackChunkName: "channel-whatsapp-old" */ "@/views/channels/whatsapp/WhatsAppOld"),
    //   meta: {
    //     title: "Canales > WhatsApp",
    //     authorizedRoles: [
    //       roles.SUPER_ADMIN,
    //       roles.ADMIN,
    //       roles.SUPERVISOR,
    //       roles.ADVISOR,
    //       roles.ENTREPRENEUR,
    //       roles.ADVISOR_LEVEL2,
    //     ],
    //   },
    // },
    {
      path: "/channels/whatsapp/apps",
      name: "channel_whatsapp_apps",
      component: () => import(/* webpackChunkName: "channel-whatsapp-apps" */ "@/views/channels/whatsapp/apps/Apps"),
      meta: {
        title: "Canales > WhatsApp > Cuentas",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/apps/connect",
      name: "channel_whatsapp_apps_connect",
      component: () =>
        import(
          /* webpackChunkName: "channel-whatsapp-apps-connect" */ "@/views/channels/whatsapp/apps/options/Connect"
        ),
      meta: {
        title: "Canales > WhatsApp > Cuentas > Conectar",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
      children: [
        {
          path: "",
          name: "whatsapp_apps_connect",
          component: () =>
            import(
              /* webpackChunkName: "whatsapp-apps-connect" */ "@/views/channels/whatsapp/apps/options/connect/Index"
            ),
          meta: {
            title: "Canales > WhatsApp > Cuentas > Conectar > Oficial",
            authorizedRoles: [roles.ENTREPRENEUR],
          },
        },
        {
          path: "non-official",
          name: "whatsapp_apps_connect_non_official",
          component: () =>
            import(
              /* webpackChunkName: "whatsapp-apps-connect-non-official" */ "@/views/channels/whatsapp/apps/options/connect/NonOfficial"
            ),
          meta: {
            title: "Canales > WhatsApp > Cuentas > Conectar > No Oficial",
            authorizedRoles: [roles.ENTREPRENEUR],
          },
        },
        {
          path: "cloudapi",
          name: "whatsapp_apps_connect_cloudapi",
          component: () =>
            import(
              /* webpackChunkName: "whatsapp-apps-connect-cloudapi" */ "@/views/channels/whatsapp/apps/options/connect/Cloudapi"
            ),
          meta: {
            title: "Canales > WhatsApp > Cuentas > Conectar > Cloud API",
            authorizedRoles: [roles.ENTREPRENEUR],
          },
        },
      ],
    },
    {
      path: "/channels/whatsapp/apps/subscribe",
      name: "whatsapp_apps_subscribe",
      component: () =>
        import(/* webpackChunkName: "whatsapp-apps-subscribe" */ "@/views/channels/whatsapp/apps/options/Subscribe"),
      meta: {
        title: "Canales > WhatsApp > Nueva aplicación",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/apps/register",
      name: "whatsapp_apps_register",
      component: () =>
        import(/* webpackChunkName: "whatsapp-apps-register" */ "@/views/channels/whatsapp/apps/options/Register"),
      meta: {
        title: "Canales > WhatsApp > Nueva aplicación",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/apps/:id/detail",
      name: "whatsapp_apps_detail",
      component: () =>
        import(/* webpackChunkName: "whatsapp-apps-detail" */ "@/views/channels/whatsapp/apps/options/Detail"),
      meta: {
        title: "Canales > WhatsApp > Detalle aplicación",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/message-templates",
      name: "channel_whatsapp_message_templates",
      component: () =>
        import(
          /* webpackChunkName: "channel-whatsapp-message-templates" */ "@/views/channels/whatsapp/message-templates/MessageTemplates"
        ),
      meta: {
        title: "Canales > WhatsApp > Plantillas de mensajes",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/message-templates/register",
      name: "whatsapp_message_templates_register",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-message-templates-register" */ "@/views/channels/whatsapp/message-templates/options/Register"
        ),
      meta: {
        title: "Canales > WhatsApp > Nueva plantillas de mensaje",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/message-templates/:id",
      name: "whatsapp_message_template_detail",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-message-template-detail" */ "@/views/channels/whatsapp/message-templates/options/Detail"
        ),
      meta: {
        title: "Canales > WhatsApp > Detalle de la plantilla de mensaje",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/message-templates/default",
      name: "whatsapp_message_templates_default",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-message-templates-default" */ "@/views/channels/whatsapp/message-templates/options/Default"
        ),
      meta: {
        title: "Canales > WhatsApp > Plantillas de mensaje predeterminadas",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/message-templates/:id/flow",
      name: "whatsapp_message_template_flow",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-message-template-flow" */ "@/views/channels/whatsapp/message-templates/options/Flow"
        ),
      meta: {
        title: "Canales > WhatsApp > Flujo de la plantilla de mensaje",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/quick-replies",
      name: "whatsapp_quick_replies",
      component: () =>
        import(/* webpackChunkName: "whatsapp-quick-replies" */ "@/views/channels/whatsapp/quick-replies/QuickReplies"),
      meta: {
        title: "Canales > WhatsApp > Respuestas rápidas",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/quick-replies/register",
      name: "whatsapp_quick_replies_register",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-quick-replies-register" */ "@/views/channels/whatsapp/quick-replies/options/Register"
        ),
      meta: {
        title: "Canales > WhatsApp > Nueva respuesta rápida",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/quick-replies/:id",
      name: "whatsapp_quick_reply_detail",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-quick-replies-detail" */ "@/views/channels/whatsapp/quick-replies/options/Detail"
        ),
      meta: {
        title: "Canales > WhatsApp > Detalle de respuesta rápida",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/actions",
      name: "whatsapp_actions",
      component: () => import(/* webpackChunkName: "whatsapp-actions" */ "@/views/channels/whatsapp/actions/Actions"),
      meta: {
        title: "Canales > WhatsApp > Acciones automáticas",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/actions/register",
      name: "whatsapp_actions_register",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-actions-register" */ "@/views/channels/whatsapp/actions/options/Register"
        ),
      meta: {
        title: "Canales > WhatsApp > Nueva acciones automática",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/actions/:id/detail",
      name: "whatsapp_action_detail",
      component: () =>
        import(/* webpackChunkName: "whatsapp-action-detail" */ "@/views/channels/whatsapp/actions/options/Detail"),
      meta: {
        title: "Canales > WhatsApp > Editar acción automática",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/actions/periodic-messages/register",
      name: "whatsapp_actions_periodic_messages_register",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-actions-periodic-messages-register" */ "@/views/channels/whatsapp/actions/periodic-messages/options/Register"
        ),
      meta: {
        title: "Canales > WhatsApp > Nuevo mensaje periódico",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/actions/periodic-messages/:id/:topic/detail",
      name: "whatsapp_actions_periodic_messages_detail",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-actions-periodic-messages-detail" */ "@/views/channels/whatsapp/actions/periodic-messages/options/Detail"
        ),
      meta: {
        title: "Canales > WhatsApp > Editar mensaje periódico",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/actions/followup-messages/register",
      name: "whatsapp_actions_followup_messages_register",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-actions-followup-messages-register" */ "@/views/channels/whatsapp/actions/followup-messages/options/Register"
        ),
      meta: {
        title: "Canales > WhatsApp > Nuevo mensaje de seguimiento",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/actions/followup-messages/:id/detail",
      name: "whatsapp_actions_followup_messages_detail",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-actions-followup-messages-detail" */ "@/views/channels/whatsapp/actions/followup-messages/options/Detail"
        ),
      meta: {
        title: "Canales > WhatsApp > Editar mensaje de seguimiento",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/actions/reply-messages/register",
      name: "whatsapp_actions_reply_messages_register",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-actions-reply-messages-register" */ "@/views/channels/whatsapp/actions/reply-messages/options/Register"
        ),
      meta: {
        title: "Canales > WhatsApp > Nuevo mensaje respuesta",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/actions/reply-messages/:id/:topic/detail",
      name: "whatsapp_actions_reply_messages_detail",
      component: () =>
        import(
          /* webpackChunkName: "whatsapp-actions-reply-messages-detail" */ "@/views/channels/whatsapp/actions/reply-messages/options/Detail"
        ),
      meta: {
        title: "Canales > WhatsApp > Editar mensaje respuesta",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/assistant",
      name: "whatsapp_assistant",
      component: () =>
        import(/* webpackChunkName: "channel-assistant" */ "@/views/channels/whatsapp/assistant/Assistant"),
      meta: {
        title: "Asistente virtual",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/assistant/models/:id",
      name: "whatsapp_assistant_model_detail",
      component: () =>
        import(
          /* webpackChunkName: "assistant-model-detail" */ "@/views/channels/whatsapp/assistant/models/options/Detail"
        ),
      meta: {
        title: "Detalle del modelo",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/whatsapp/settings",
      name: "whatsapp_settings",
      component: () =>
        import(/* webpackChunkName: "whatsapp-settings" */ "@/views/channels/whatsapp/settings/Settings"),
      meta: {
        title: "Configuración",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/mail",
      name: "channel_mail",
      component: () => import(/* webpackChunkName: "channel-mail" */ "@/views/channels/mail/Mail"),
      meta: {
        title: "Canales > Bandeja de correo",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/ecommerce",
      name: "channel_ecommerce",
      component: () => import(/* webpackChunkName: "channel-ecommerce" */ "@/views/channels/ecommerce/Ecommerce"),
      meta: {
        title: "Canales > Comercio electrónico",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/ecommerce/default",
      name: "ecommerce_detail",
      component: () =>
        import(/* webpackChunkName: "channel-ecommerce-detail" */ "@/views/channels/ecommerce/options/Detail"),
      meta: {
        title: "Canales > Comercio electrónico",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/landing-page",
      name: "channel_landing_page",
      component: () =>
        import(/* webpackChunkName: "channel-landing-page" */ "@/views/channels/landing-page/LandingPage"),
      meta: {
        title: "Canales > Landing Page",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/landing-page/register",
      name: "landing_page_register",
      component: () =>
        import(
          /* webpackChunkName: "channel-landing-page-register" */ "@/views/channels/landing-page/options/Register"
        ),
      meta: {
        title: "Canales > Landing Page > Nuevo",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/landing-page/:id",
      name: "landing_page_detail",
      component: () =>
        import(/* webpackChunkName: "channel-landing-page-detail" */ "@/views/channels/landing-page/options/Detail"),
      meta: {
        title: "Canales > Landing Page > Detalle",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/embed-forms",
      name: "embed_forms",
      component: () => import(/* webpackChunkName: "channel-embed-forms" */ "@/views/channels/embed-forms/EmbedForms"),
      meta: {
        title: "Canales > Formularios",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/link-pages",
      name: "link_pages",
      component: () => import(/* webpackChunkName: "channel-link-pages" */ "@/views/channels/link-pages/LinkPages"),
      meta: {
        title: "Canales > Páginas de enlace",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/link-pages/register",
      name: "link_pages_register",
      component: () =>
        import(/* webpackChunkName: "link-pages-register" */ "@/views/channels/link-pages/options/Register"),
      meta: {
        title: "Canales > Nueva página de enlace",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/link-pages/:id",
      name: "link_pages_detail",
      component: () =>
        import(/* webpackChunkName: "link-pages-detail" */ "@/views/channels/link-pages/options/Detail"),
      meta: {
        title: "Canales > Página de enlace",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/embed-forms/register",
      name: "embed_forms_register",
      component: () =>
        import(/* webpackChunkName: "embed-forms-register" */ "@/views/channels/embed-forms/options/Register"),
      meta: {
        title: "Canales > Nuevo formulario",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/embed-forms/:id",
      name: "embed_forms_detail",
      component: () =>
        import(/* webpackChunkName: "embed-forms-detail" */ "@/views/channels/embed-forms/options/Detail"),
      meta: {
        title: "Canales > Formulario",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/custom-forms",
      name: "custom_forms",
      component: () =>
        import(/* webpackChunkName: "channel-custom-forms" */ "@/views/channels/custom-forms/CustomForms"),
      meta: {
        title: "Canales > Página agente",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/custom-forms/register",
      name: "custom_forms_register",
      component: () =>
        import(/* webpackChunkName: "custom-forms-register" */ "@/views/channels/custom-forms/options/Register"),
      meta: {
        title: "Canales > Configurar formulario",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/channels/custom-forms/:id",
      name: "custom_forms_detail",
      component: () =>
        import(/* webpackChunkName: "custom-forms-detail" */ "@/views/channels/custom-forms/options/Detail"),
      meta: {
        title: "Canales > Formulario",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/statistics",
      name: "statistics",
      component: () => import(/* webpackChunkName: "statistics" */ "@/views/statistics/Statistics"),
      meta: {
        title: "Métricas",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/statistics/project50",
      name: "statistics_project50",
      component: () => import(/* webpackChunkName: "statistics-project50" */ "@/views/statistics/wegrou/Project50"),
      meta: {
        title: "Reporte Proyecto 50",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/segments",
      name: "segments",
      component: () => import(/* webpackChunkName: "segments" */ "@/views/segments/Segments"),
      meta: {
        title: "Segmentos",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR, roles.SUPERVISOR],
      },
    },
    {
      path: "/segments/register",
      name: "segment_register",
      component: () => import(/* webpackChunkName: "segments-register" */ "@/views/segments/options/Register"),
      meta: {
        title: "Segmentos",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR, roles.SUPERVISOR],
      },
    },
    {
      path: "/segments/downloads",
      name: "segment_downloads",
      component: () => import(/* webpackChunkName: "segments-downloads" */ "@/views/segments/options/Downloads"),
      meta: {
        title: "Descarga de segmentos",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR, roles.SUPERVISOR],
      },
    },
    {
      path: "/segments/automations",
      name: "segment_automations",
      component: () => import(/* webpackChunkName: "segments-automations" */ "@/views/segments/options/Automations"),
      meta: {
        title: "Segmentos",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR, roles.SUPERVISOR],
      },
    },
    {
      path: "/settings",
      name: "settings",
      component: () => import(/* webpackChunkName: "settings" */ "@/views/settings/Settings"),
      meta: {
        title: "Configuraciones",
        authorizedRoles: allRoles,
      },
    },
    {
      path: "/notifications",
      name: "notifications",
      component: () => import(/* webpackChunkName: "notifications" */ "@/views/notifications/Notifications"),
      meta: {
        title: "Notificaciones",
        authorizedRoles: allRoles,
      },
    },
    {
      path: "/subscriptions",
      name: "subscriptions",
      component: () => import(/* webpackChunkName: "subscriptions" */ "@/views/subscriptions/Subscriptions"),
      meta: {
        title: "Suscripción",
        authorizedRoles: [roles.ENTREPRENEUR],
      },
    },
    {
      path: "/subscription-required",
      name: "subscription-required",
      component: () =>
        import(/* webpackChunkName: "subscription-required" */ "@/views/subscriptions/SubscriptionRequired"),
      meta: {
        title: "Es necesaria una suscripción activa",
        authorizedRoles: [roles.ENTREPRENEUR, roles.ADVISOR_LEVEL1],
      },
    },
    {
      path: "/menu",
      name: "menu",
      component: () => import(/* webpackChunkName: "menu" */ "@/views/menu/Menu"),
      meta: {
        title: "Menu",
        authorizedRoles: allRoles,
      },
    },
    {
      path: "/warehouse/warehouses",
      name: "warehouse_warehouses",
      component: () => import(/* webpackChunkName: "warehouse-warehouses" */ "@/views/warehouse/warehouses/Warehouses"),
      meta: {
        title: "Almacenes",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/warehouse/warehouses/register",
      name: "warehouse_warehouses_register",
      component: () =>
        import(/* webpackChunkName: "warehouse-warehouses-register" */ "@/views/warehouse/warehouses/options/Register"),
      meta: {
        title: "Nuevo almacén",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/warehouse/stock",
      name: "warehouse_stock",
      component: () => import(/* webpackChunkName: "warehouse-stock" */ "@/views/warehouse/stock/Stock"),
      meta: {
        title: "Stock",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/warehouse/stock/purchase",
      name: "warehouse_stock_purchase",
      component: () =>
        import(/* webpackChunkName: "warehouse-stock-purchase" */ "@/views/warehouse/stock/options/Purchase"),
      meta: {
        title: "Stock > Nuevo ingreso",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/warehouse/stock/transfer",
      name: "warehouse_stock_transfer",
      component: () =>
        import(/* webpackChunkName: "warehouse-stock-transfer" */ "@/views/warehouse/stock/options/Transfer"),
      meta: {
        title: "Stock > Transferencia",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/warehouse/stock/merma",
      name: "warehouse_stock_merma",
      component: () => import(/* webpackChunkName: "warehouse-stock-merma" */ "@/views/warehouse/stock/options/Merma"),
      meta: {
        title: "Stock > Merma",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "/warehouse/logs",
      name: "warehouse_logs",
      component: () => import(/* webpackChunkName: "warehouse-log" */ "@/views/warehouse/logs/Logs"),
      meta: {
        title: "Movimientos",
        authorizedRoles: [roles.ADMIN, roles.SUPER_ADMIN, roles.ENTREPRENEUR],
      },
    },
    {
      path: "*",
      redirect: "/login",
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  let authorizedRoles = to.meta.authorizedRoles || [];
  let user = store.state.Agent.agent;

  if (!user) {
    let currentUser = await getCurrentUser();
    user = currentUser;

    if (currentUser && currentUser.role && currentUser.role !== "anonymous") {
      await store.dispatch("getCurrentAgent", { uid: currentUser.uid });

      user = store.state.Agent.agent;
    }
  }

  if (!authorizedRoles.includes(user.role)) {
    if (user.role === "anonymous") {
      next("/login");
    } else {
      if (!user.role) {
        if (to.path !== "/affiliate-business") next("/affiliate-business");
        else next();
      } else next("/");
    }
  } else {
    to.meta.user = user;
    if (!user.role && to.path !== "/affialiate-business") next("/affiliate-business");
    else next();
  }
});

export default router;
